import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import { useUpsertInternationalTemplateForm } from "./upsertInternationalTemplate.form";

import type { ReactLocalization } from "@fluent/react";
import type { UpsertInternationalTemplateFormFields } from "./upsertInternationalTemplate.form";
import type { UseFormReturn } from "react-hook-form";

type UpsertInternationalTemplateFormReturnType =
  UseFormReturn<UpsertInternationalTemplateFormFields>;

const UpsertInternationalTemplateContext =
  createContext<UpsertInternationalTemplateFormReturnType>(
    {} as UpsertInternationalTemplateFormReturnType,
  );

export const useUpsertInternationalTemplateContext = () =>
  useContext(UpsertInternationalTemplateContext);

export const UpsertInternationalTemplateFormProvider = ({
  children,
  l10n,
}: {
  children: ReactNode;
  l10n?: ReactLocalization;
}) => {
  const form = useUpsertInternationalTemplateForm(l10n);
  return (
    <UpsertInternationalTemplateContext.Provider value={{ ...form }}>
      {children}
    </UpsertInternationalTemplateContext.Provider>
  );
};
